import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { Auth } from '@jg/auth';
import { apiActions } from '..';
import { IAppState } from '../../types/state.d';
import { apiThunk } from './index';
import { IEditTeamFormProps } from '../../containers/EditTeam/EditTeam.d';

const editTeam = ({
  teamName,
  story,
  heroImage,
  fundraisingTarget,
}: IEditTeamFormProps) => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
) => {
  try {
    const storyData = { story, heroImage };
    dispatch(apiActions.submitTeamDataRequestMade());

    await dispatch(apiThunk.updateTeamName(teamName));
    await dispatch(apiThunk.updateFundraisingData(fundraisingTarget));
    await dispatch(apiThunk.updateStory(storyData));

    dispatch(
      apiActions.submitTeamDataRequestSuccess({
        teamName,
        story,
        heroImage,
        fundraisingTarget,
      }),
    );
  } catch (error) {
    dispatch(apiActions.submitTeamDataRequestError(error.message));
    throw error;
  }
};

export default editTeam;
